export const DEFAULT_MAX_CHARS_BEFORE_ELLIPSIS = 100;

/** Ellipts the given text. By default, ellipts after 100 characters. */
export const ellipt = (text: string, maxCharsBeforeEllipsis: number = DEFAULT_MAX_CHARS_BEFORE_ELLIPSIS): string => {
    return text.length > maxCharsBeforeEllipsis ? `${text.substring(0, maxCharsBeforeEllipsis)}...` : text;
};

/**
 * Converts an enum value (e.g., DRAFT_STATUS, control_user, LOW_MODERATE) to title case (e.g., Draft Status, Control User, Low/Moderate).
 * Note that a coding standard has been established that enum values should always be written in Title Case, this is just intended to handle legacy enum values.
 * @param value The string (enum value) to convert to Title Case.
 * @param separator The character used to separate the words in the title case string. Defaults to a space. Another common option is a forward slash ('/').
 */
export const toTitleCase = (value?: string, separator: string = ' '): string => {
    if (!value) {
        return '';
    }

    value = value.toLowerCase();

    // Assumes the words in the string are separated by a single underscore.
    const words = value.split('_');

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i].trim();

        // Always capitalize the first letter of the first and last word.
        if (i === 0 || i === words.length - 1) {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
            continue;
        }

        // Do not capitalize articles.
        if (['a', 'an', 'the'].includes(words[i])) {
            continue;
        }

        // Do not capitalize coordinating conjunctions.
        if (['and', 'but', 'or', 'nor', 'for', 'so', 'yet'].includes(words[i])) {
            continue;
        }

        // Do not capitalize prepositions with fewer than 4 letters.
        if (['at', 'by', 'in', 'of', 'on', 'to', 'up', 'off', 'out', 'per', 'via'].includes(words[i]) && words[i].length < 4) {
            continue;
        }

        // Otherwise, capitalize the first letter of the word.
        if (words[i].length > 0) {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
    }

    return words.join(separator);
};
